import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import CallLogsReport from "../../components/DailyReport/CallLogs-Report"

const ReportCallLogs = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Call Logs Report | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <CallLogsReport />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ReportCallLogs
